// PLUGINS IMPORTS //
import React from "react"
import styled from "styled-components/macro"

// COMPONENTS IMPORTS //
import NavItem from "./NavItem/NavItem"
import { memoComparison } from "Content/Shared/Helpers/Functions/Functions"

// EXTRA IMPORTS //
import { iPadResolution } from "Content/Shared/Styles/Theme"
import { NavigationItemType } from "../SideNavigation"

/////////////////////////////////////////////////////////////////////////////

type PropsType = {
  open: boolean
  setOpen: (open: boolean) => void

  links: Array<NavigationItemType>
}

const Panel: React.FC<PropsType> = (props) => {
  return (
    <Wrapper open={props.open}>
      {props.links.map((item) => (
        <NavItem item={item} setOpen={props.setOpen} />
      ))}
    </Wrapper>
  )
}

/////////////////////////////////////////////////////////////////////////////

const Wrapper = styled.ul`
  list-style: none;
  display: flex;
  flex-flow: row nowrap;
  z-index: 1;
  display: none;
  align-items: flex-start;

  @media (max-width: ${iPadResolution}px) {
    display: flex;

    flex-flow: column nowrap;
    background-color: white;
    margin-top: -10px;
    position: fixed;
    top: 0;
    right: 0;
    height: 100vh;
    width: 100%;
    padding-top: 3.5rem;
    transition: transform 0.3s ease-in-out;

    transform: ${({ open }: { open: boolean }) =>
      open ? "translateX(0)" : "translateX(100%)"};
  }
`

export default React.memo(Panel, memoComparison)
